module.exports = __webpack_public_path__ + "static/media/lepes5.b4afcf12.png";